import React from 'react';

import Header from './Header';
import styles from './index.module.css';
import Navigation from './Navigation';

const Layout = ({ children }) => {
  return (
    <div className={styles.container}>
      <Navigation />
      <div className={styles.mainContent}>
        <Header />
        <div className={styles.page} data-e2e-widget-type="pageContainerWidget">
          {children}
        </div>
      </div>

      <div id="modal-root" />
    </div>
  );
};

export default Layout;
